import { useClientStore } from '../store/client'

export default defineNuxtRouteMiddleware(() => {
  const client = useClientStore()
  if (!client.representativeRole) {
    return client.redirect()
  }
})
